import axios from "axios"

const controller = "/rol"

const RolService = {
    buscar: async (rol) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            rol
        })
        return data
    },
}

export default RolService